import { cn } from '../../lib/utils';

export function HeartButton({
  active,
  onToggle,
  size = 30,
}: {
  active: boolean;
  onToggle: () => void;
  size?: number;
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      aria-label={active ? 'Прибрати з улюбленого' : 'Додати в улюблене'}
      onClick={onToggle}
      style={{ fontSize: size }}
      className={cn(
        'btn-press bg-transparent border-none leading-none cursor-pointer p-0',
        active ? 'text-accent' : 'text-heart-off hover:text-muted',
      )}
    >
      ♥
    </button>
  );
}
